import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { MeetingMaster } from '../../models/meetingmaster';
import { MeetingMasterService } from '../../services/meetingmaster.service';
import { CommitteeService } from '../../services/committee.service';
import { DatePipe } from '@angular/common';
import { MeetingtypeService } from '../../services/meetingtype.service';
import { Meetingtype } from '../../models/meetingtype';

@Component({
  selector: 'app-meetingmaster',
  templateUrl: './meetingmaster.component.html',
  styleUrls: ['./meetingmaster.component.css']
})
export class MeetingmasterComponent implements OnInit {

  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerMeeting: PageHeader;
  entity: MeetingMaster = new MeetingMaster();
  selectedMeeting: MeetingMaster = new MeetingMaster();
  editingEntity: MeetingMaster = new MeetingMaster();
  Meeting: any;
  MeetingColumns: any[];
  listView: boolean = true;
  formCaption: string = '';
  locations: Array<Location> = [];
  selectedLocation: any;
  _selectedMeeting: any;
  employees: Array<Meetingtype> = [];
  selectedEmployee: any;
  selectedmeeting: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  departments: Array<Department> = [];
  pipe = new DatePipe('en-US');
  constructor(
    private _departmentService: DepartmentService,
    private _MeetingtypeService: MeetingtypeService,
    private _MeetingMasterService: MeetingMasterService,
    private _committeeService: CommitteeService,
    private _locationService: LocationService,
    private _employeeService: EmployeeService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerMeeting = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.MeetingColumns = [
      { field: "SlNo", title: '#', filter: false, sortable: true, width: 100 },
      { field: "MeetingName", title: 'Meeting Name', filter: true, sortable: true },
      { field: "MeetingDescription", title: 'Description ', filter: true, sortable: true },
      { field: "MeetingTypeName", title: 'Meeting Type ', filter: true, sortable: true },
      { field: "Active", title: 'Active', filter: true, sortable: true },
    ];

    this.Meeting = [];
    this.getAllMeeting();

  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._MeetingMasterService.getAllMeeting('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<MeetingMaster>) => {
      this.Meeting = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._MeetingMasterService.getAllMeeting(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((Meeting: Array<MeetingMaster>) => {
        this.Meeting = {
          data: Meeting,
          total: Meeting[0] ? Meeting[0].TotalCount : 0
        }
      });
    }
  }
  getAllMeeting() {
    this._MeetingMasterService.getAllMeeting('', Number(this.defaultPageSize), 1, 0, 0).subscribe((Meeting: Array<MeetingMaster>) => {
      this.Meeting.DateOfFormation = new Date(this.Meeting.DateOfFormation)

      this.Meeting = Meeting;
      for (let i = 0; i < Meeting.length; i++) {
        this.Meeting[i].DateOfFormation = this.pipe.transform(this.Meeting[i].DateOfFormation, "dd/MM/yyyy");


      }
      this.Meeting = {

        data: Meeting,
        total: Meeting[0] ? Meeting[0].TotalCount : 0
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._MeetingMasterService.deleteMeeting(this.selectedMeeting.Meeting_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearMeeting();
            this.getAllMeeting();
          },
          )
        }
      }
    });
  }
  getAllMeeting_type(filter: string) {
    this._MeetingtypeService.getAllMeetingtype(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Meetingtype>) => {
      this.employees = data;
    })
  }
  initPageHeader(): PageHeader {
    let headerMeeting = new PageHeader();
    headerMeeting.PageCaption = "Meeting ";
    headerMeeting.IconClass = "bi bi-shield-shaded";
    return headerMeeting;
  }

  deleteMeeting(event: any) {
    if (event.seletedRows[0]) {
      this.selectedMeeting.Meeting_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Meeting",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addMeeting(event: any) {
    this.listView = false;
    this.clearMeeting();
    this.getAllMeeting_type('');
    this.formCaption = "Add Meeting";
  }

  editMeeting(event: any): void {
    if (event.seletedRows[0]) {
      this._MeetingMasterService.viewMeeting(event.seletedRows[0]).subscribe((Meeting: Array<MeetingMaster>) => {
        let editEnity = Meeting[0] ? Meeting[0] : new this.Meeting();

        if (editEnity) {
          this.selectedmeeting = { MeetingType_Id: editEnity.MeetingType_Id, MeetingTypeName: editEnity.MeetingTypeName };

          this.editingEntity = editEnity;
          this.entity = { ...this.editingEntity };
          this.getAllMeeting_type('');
          this.listView = false;
          this.formCaption = "Edit Meeting  ";

          this.entity.EntityMetaData = [
            //{ FieldName: 'MeetingName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Meeting Name is required' },
            { FieldName: 'MeetingDescription', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Code is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    //this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._MeetingMasterService.checkDuplication(this.entity.MeetingName, this.entity.Meeting_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Meeting  already exists');
          this.saveDisabled = false;
        }
        else {
          this._MeetingMasterService.saveMeeting(this.entity).subscribe(() => {
            if (this.entity.Meeting_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearMeeting();
            this.getAllMeeting();
          })
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }


  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllMeeting();
  }

  refreshDepartments(event: any): void {
    this.Meeting=[];
    this.getAllMeeting();
  }

  clearMeeting(): void {
    this._selectedMeeting = {};

    this.entity = new MeetingMaster();

    this.saveDisabled = false;

  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}

